import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import React from 'react';
import { ContentTemplate, HeaderTemplate, Link, TitleHeader } from 'web-library';
import MuiBreadCrumbs from 'web-library/stories/molecule/BreadCrumbs/MuiBreadCrumbs';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import RouteKey from '../../../routes/key';
import CreateCandidateForm from '../../accountManagement/CreateCandidateForm';

const { createCandidate } = RouteKey.auth.child;
const { error: errorRoute } = RouteKey.child;

const CreateAccountManagement = () => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <HeaderTemplate>
        {!isMobile && (
            <MuiBreadCrumbs separator="NextIcon">
              <Link href="/">{t('profile->>CreateCandidateForm.Login')}</Link>
              <>{t('profile->>CreateCandidateForm.CreateAccount')}</>
            </MuiBreadCrumbs>
        )}
      </HeaderTemplate>
      <TitleHeader title={t('profile->>CreateCandidateForm.CreateAccount')} />
      <ContentTemplate type="full">
        <Switch>
          <Route exact path={`${path}`}>
            <Redirect to={`${path}/${createCandidate}`} />
          </Route>
          <Route path={`${path}/${createCandidate}`}>
            <CreateCandidateForm />
          </Route>
          <Route path="*" exact>
            <Redirect to={`/${errorRoute}`} />
          </Route>
        </Switch>
      </ContentTemplate>
    </>
  );
};

export default CreateAccountManagement;
